import moment from "moment-timezone";
import ICustomer from "../models/ICustomer";
import { ITransaction } from "../models/ITransaction ";
import { IWin } from "../models/IWin";
import { IDetailedWin } from "../models/IWinForExcel";
import { getDateAndTime } from "./ToDateFormat";

/** לקוח רק דרך raffleParticipation — transaction.customer אינו נתמך */
function getTransactionCustomer(
  transaction?: ITransaction
): ICustomer | undefined {
  return transaction?.raffleParticipation.customer;
}

export function convertWinsForExcel(oldWins: IWin[]): IDetailedWin[] {
  let newArray: IDetailedWin[] = [];
  oldWins.map((oldRow) => {
    const customer = getTransactionCustomer(oldRow.card?.transaction);
    let newRow: IDetailedWin = {
      isSelected: oldRow.isSelected || false,
      canceledDate: getDateAndTime(oldRow.canceledDate ?? undefined),
      canceledReason: oldRow.canceledReason ?? "",
      cancelingUsername: oldRow.cancelingUser?.userName ?? "",
      cardNumber: oldRow.card?.number,
      isLoyalty: oldRow.card?.isLoyalty ?? false,
      customerCity: customer?.city ?? "",
      customerEmail: customer?.email ?? "",
      created: getDateAndTime(oldRow.created),
      customerName: customer?.firstName
        ? `${customer.firstName} ${customer.lastName ?? ""}`.trim()
        : "",
      customerIdNumber: customer?.misparZehut ?? "",
      customerStreet: customer?.street ?? "",
      customerMobilePhone: customer?.mobilePhone ?? "",
      isCanceled: oldRow.isCanceled,
      isCanceledLabel: oldRow.isCanceled ? "כן" : "לא",
      transactionTypeLabel:
        oldRow.card?.transaction?.type === "in_store"
          ? "בחנות"
          : oldRow.card?.transaction?.type === "online"
          ? "באתר"
          : "",
      isManual: oldRow.card?.transaction?.isManual ?? false,
      isManualLabel: oldRow.card?.transaction?.isManual ? "כן" : "לא",
      isCustomerAllowMailing: customer?.allowMailing ?? false,
      isOneTimeWin: oldRow.rafflePrize?.prize?.isOneTimeWin,
      raffleDate: getDateAndTime(oldRow.rafflePrize?.raffle?.raffleDate),
      raffleDateRaw: oldRow.rafflePrize?.raffle?.raffleDate ?? undefined,
      winId: oldRow.id,
      orderDate: getDateAndTime(oldRow.card?.transaction?.registrationDate),
      raffleEndDate: getDateAndTime(oldRow.rafflePrize?.raffle?.endDate),
      raffleId: oldRow.rafflePrize?.raffle?.id,
      rafflePrizeId: oldRow.rafflePrize?.id,
      prizeName: oldRow.rafflePrize?.prize?.name,
      priority: oldRow.rafflePrize?.priority,
      raffleStartDate: getDateAndTime(oldRow.rafflePrize?.raffle?.startDate),
      rafflingUsername: oldRow.rafflingUser?.userName ?? "",
      registrationDate: getDateAndTime(
        oldRow.card?.transaction?.registrationDate
      ),
      store: oldRow.card?.transaction?.store ?? "",
      total: oldRow.card?.transaction?.total ?? "",
      transactionNumber: oldRow.card?.transaction?.number ?? "",
      receiptNumber: oldRow.card?.transaction?.receiptNumber ?? "",
      transactionType: oldRow.card?.transaction?.type,
    };
    newArray.push(newRow);
  });
  return newArray;
}
